import axios from "axios";
import { BASE_URL } from "../configs/constants";
import LocalStorageService from "./localStorageService";

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = (cname) => {
  const name = cname + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const checkCookie = (cname) => {
  const user = getCookie(cname);
  if (user != "") {
    return true;
  } else {
    /*  user = prompt("Please enter your name:", "");
     if (user != "" && user != null) {
       setCookie("username", user, 365);
     } */
    return false;
  }
};

export const deleteCookie = (cname, path = "/") => {
  document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path};`;
};

export const getDefaultNav = (nav) => {
  if (!nav) return;
  switch (nav) {
    case "comm":
      return "/comm";
    case "settings":
      return "/control-center";
    case "roaster":
      return "/roaster";
    default:
      return `/${nav}`;
  }
};

export function downloadCsvLocal(csvString: string, filename = "report.csv") {
  // Add BOM so Excel opens UTF-8 correctly
  const BOM = "\uFEFF";
  // Normalize newlines so Excel doesn’t merge rows
  const normalized = csvString.replace(/\r?\n/g, "\r\n");

  const blob = new Blob([BOM + normalized], {
    type: "text/csv;charset=utf-8",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
export async function downloadOldDriverPdf(driver: any) {
  const dusionId = driver?.fusionId;
  const url = `${BASE_URL}/user/get-old-driver-documents/${dusionId}`;
  return downloadDriverDocument(url, dusionId)

}

export async function downloadNewDriverPdf(driver: any) {
  const documentId = driver?.documentId;
  const url = `${BASE_URL}/user/get-driver-document/${documentId}`;
  return downloadDriverDocument(url, documentId)
}

async function downloadDriverDocument(url, identifier) {
  const token = LocalStorageService.getAccessToken();

  const resp = await axios.get(url, {
    responseType: "arraybuffer", // get raw bytes
    withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  const blob = new Blob([resp.data], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = `document_${identifier || "file"}.pdf`; // force .pdf
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1500);
}
